import styled from 'vue-styled-components';

export const SchedulesContent = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin-bottom: 20px;
`;

export const AddScheduleButton = styled.button`
    display: flex;
    padding: var(--Space-0, 0px);
    justify-content: center;
    align-items: center;
    border-radius: var(--Radius-25, 2px);
    border: 1px solid #e2e7eb;
    background: #fff;
    cursor: pointer;
    color: #3c464f;

    font-family: var(--font-family-primary);
    font-weight: 500;
    font-size: 13px;
    line-height: 140%;
    letter-spacing: 0px;
    text-align: center;

    padding: 8px 12px;
    height: 40px;

    svg {
        width: 16px;
        height: 16px;
        margin-right: 2px;
        fill: #3c464f;
    }
`;

export const ScheduleItemContainer = styled.div`
    position: relative;
    display: flex;
    align-items: center;
    width: 100%;
    gap: 8px;
`;

export const RemoveButton = styled.button`
    background: transparent;
    border: none;
    cursor: pointer;
    padding: 5px 0;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #666;

    &:hover {
        color: #ff4d4f;
    }
`;

export const ErrorMessage = styled.div`
    color: #c72e2c;
    font-size: 12px;
`;

export const ScheduleItemWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
`;
